export default __webpack_public_path__ + "logo.f7321a9288347d9cd93dbc227c314780.png";